import { useQueryUsageInformation } from 'src/services/queries'
import { UserRole } from 'src/utils/constants/enum'

const useTeamMember = () => {
  const { data: { data } } = useQueryUsageInformation()
  const isOwner = data?.role === UserRole.OWNER
  const isTeamMember = !!(data?.team_id && data?.role === UserRole.MEMBER)

  return { isOwner, isTeamMember }
}

export default useTeamMember